import axios from 'axios';
import { BASE_URLS, ENV_CONFIG } from '../../shared/config/env';

const GUEST_PAYMENT_BASE = BASE_URLS.POP.replace('/payment/', '/payment-link/');

const createGuestClient = (token) => {
    const client = axios.create({
        baseURL: GUEST_PAYMENT_BASE,
        timeout: ENV_CONFIG.apiTimeout,
    });
    client.interceptors.request.use((config) => {
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['device-platform'] = 7;
        return config;
    });
    return client;
};

export const guestPaymentService = (token) => {
    const client = createGuestClient(token);
    return {
        validateToken: () =>
            client.get(`pay/${token}`),

        getOrgPaymentMethods: (orgGuid) =>
            client.get(`/organisation/${orgGuid}/methods`, {
                params: { 'filter[is_active]': 1, expand: 'method_configuration,currencies' },
            }),

        initialise: (data = {}) =>
            client.post(`/pay/${token}/initialise`, data),

        verify: (data = {}) =>
            client.post(`/pay/${token}/verify`, data),
    };
};
